import { render, staticRenderFns } from "./ParameterPage.vue?vue&type=template&id=23719c77&"
import script from "./ParameterPage.vue?vue&type=script&lang=js&"
export * from "./ParameterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports